import { Expose } from 'class-transformer';

export class ProductVariationMetadataDtoMap {
  @Expose()
  voucherMno?: string;

  @Expose()
  voucherProductCode?: string;

  @Expose()
  voucherAmount?: number;
}
